import React, { useState, useEffect, useContext, useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import auth from "../services/auth";
import Spinner from "../elements/Spinner";
import AppContext from "../contexts/AppContext";
import api from "../services/api";
// import ls from "local-storage";
import emailValidate from "../services/emailValidate";
// import ls from "services/ls";
// import passwordValidate from "../services/passwordValidate";
import { __ } from "services/Translator";
// import DatePickerNew from "./DatePicker";

import validator from "validator";
import swal from "sweetalert";

// import FacebookLogin from "react-facebook-login";
// import GoogleLogin from "react-google-login";

// import SocialRegister from "elements/SocialRegister";
// import SocialLogin from "elements/SocialLogin";

// import SocialLogin from "./SocialLogin";
import { Modal, Button } from "react-bootstrap";

import DatePicker from "react-datepicker";
import { addDays } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";

const LoginReg = (props) => {
  const history = useHistory();
  const [spinner, setSpinner] = useState(false);
  const { updateUserObj } = useContext(AppContext);
  const [alertMsg, setAlertMsg] = useState({
    message: "Successfully added",
    variant: "success",
    showAlert: false,
  });

  const autofocusName = (item) => {
    // document.querySelector("input[name=" + item + "]").focus();
    document.querySelector("#" + item).focus();
  };

  // Login reg modal
  const [activeTab, setActiveTab] = useState("login");
  const [showLoginModal, setShowLoginModal] = useState(false);
  const closeLoginModal = () => {
    setShowLoginModal(false);
    setActiveTab("login");
    props.setModalLoginPropsData(false);
    props.setModalSignUpPropsData(false);
  };

  // register functionalities
  const [errors, setErrors] = useState({});
  // const params = queryString.parse(window.location.search).p;

  const [showRegisterPass, setShowRegisterPass] = useState(false);

  const toggleShowRegisterPass = () => {
    if (showRegisterPass) {
      setShowRegisterPass(false);
    } else {
      setShowRegisterPass(true);
    }
  };

  const registerValidateForm = () => {
    var valid = true;
    // return valid;
    var errorsTmp = {};
    // alert(44);
    if (registerData.firstName < 2 || registerData.firstName.length > 250) {
      errorsTmp = { ...errorsTmp, firstName: __("Please enter first name") };
      valid = false;
    }
    if (registerData.lastName < 2 || registerData.lastName.length > 250) {
      errorsTmp = { ...errorsTmp, lastName: __("Please enter last name") };
      valid = false;
    }
    if (registerData.email < 2 || registerData.email.length > 250) {
      errorsTmp = { ...errorsTmp, email: __("Please enter your email") };
      valid = false;
    }
    if (!emailValidate(registerData.email)) {
      errorsTmp = { ...errorsTmp, email: __("Your email not valid") };
      valid = false;
    }
    if (registerData.phone < 2 || registerData.phone.length > 250) {
      errorsTmp = { ...errorsTmp, phone: __("Please enter your phone") };
      valid = false;
    }
    if (registerData.password < 2 || registerData.password.length > 250) {
      errorsTmp = { ...errorsTmp, password: __("Please enter password") };
      valid = false;
    }
    if (registerData.dateOfBirth < 2 || registerData.dateOfBirth.length > 250) {
      errorsTmp = {
        ...errorsTmp,
        dateOfBirth: __("Please enter your birthday"),
      };
      valid = false;
    }

    if (registerData.agreeToTerms !== 1) {
      errorsTmp = {
        ...errorsTmp,
        agreeToTerms: __("Please read & accept terms & privacy policy"),
      };
      valid = false;
    }
    // if (registerData.accept_country_limit !== "yes") {
    //   errorsTmp = {
    //     ...errorsTmp,
    //     accept_country_limit: __("Please read & accept country policy"),
    //   };
    //   valid = false;
    // }
    setErrors(errorsTmp);
    return valid;
  };
  const updateRegisterForm = (field, value) => {
    setRegisterData({ ...registerData, [field]: value });
  };
  const [acceptField, setAcceptField] = useState({
    firstName: 0,
    lastName: 0,
    email: 0,
    phone: 0,
    password: 0,
    // confirm_password: 0,
    dateOfBirth: 0,
  });
  const registerInputChange = (ev) => {
    var target = ev.target;
    var field = target.name;
    var value = target.value;

    // accept_country_limit: false,

    if (field == "agreeToTerms") {
      var checked = ev.target.checked;
      if (checked) {
        value = 1;
      } else {
        value = 0;
      }
    }
    if (field == "accept_country_limit") {
      var checked = ev.target.checked;
      if (checked) {
        value = "yes";
      } else {
        value = "no";
      }
    }

    if (field == "firstName") {
      if (value.length > 2) {
        setAcceptField({ ...acceptField, firstName: 1 });
        setErrors({ ...errors, firstName: "" });
      } else {
        setAcceptField({ ...acceptField, firstName: 2 });
        setErrors({ ...errors, firstName: __("Please enter first name") });
      }
    }
    if (field == "lastName") {
      if (value.length > 2) {
        setAcceptField({ ...acceptField, lastName: 1 });
        setErrors({ ...errors, lastName: "" });
      } else {
        setAcceptField({ ...acceptField, lastName: 2 });
        setErrors({ ...errors, lastName: __("Please enter last name") });
      }
    }
    if (field == "email") {
      if (emailValidate(value)) {
        setAcceptField({ ...acceptField, email: 1 });
        setErrors({ ...errors, email: "" });
      } else {
        setAcceptField({ ...acceptField, email: 2 });
        setErrors({ ...errors, email: __("Your email not valid") });
      }
    }
    if (field == "phone") {
      if (value.length > 2) {
        setAcceptField({ ...acceptField, phone: 1 });
        setErrors({ ...errors, phone: "" });
      } else {
        setAcceptField({ ...acceptField, phone: 2 });
        setErrors({ ...errors, phone: __("Please enter phone") });
      }
    }
    if (field == "password") {
      if (
        validator.isStrongPassword(value, {
          minLength: 8,
          minLowercase: 1,
          minUppercase: 1,
          minNumbers: 1,
          minSymbols: 1,
        })
      ) {
        setAcceptField({ ...acceptField, password: 1 });
        setErrors({ ...errors, password: "" });
      } else {
        setAcceptField({ ...acceptField, password: 2 });
        setErrors({
          ...errors,
          password: __(
            "Your password must contain between 8 and 30 characters, including at least one number, one special character, one lowercase and one upercase. Do not use your email address or username as your password."
          ),
        });
      }
    }
    // if (field == "confirm_password") {
    //   var password = registerData.password;
    //   if (value === password) {
    //     setAcceptField({ ...acceptField, confirm_password: 1 });
    //     setErrors({ ...errors, confirm_password: "" });
    //   } else {
    //     setAcceptField({ ...acceptField, confirm_password: 2 });
    //     setErrors({
    //       ...errors,
    //       confirm_password: __("password doesn't match"),
    //     });
    //   }
    // }
    if (field == "dateOfBirth") {
      if (value.length > 2) {
        setAcceptField({ ...acceptField, dateOfBirth: 1 });
        setErrors({ ...errors, dateOfBirth: "" });
      } else {
        setAcceptField({ ...acceptField, dateOfBirth: 2 });
        setErrors({ ...errors, dateOfBirth: __("Please enter birthday") });
      }
    }
    updateRegisterForm(field, value);
  };

  const [registerData, setRegisterData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    password: "",
    dateOfBirth: "",
    agreeToTerms: 0,
    accept_country_limit: "no",
  });

  const registerAction = async (event) => {
    event.preventDefault();
    var valid = registerValidateForm();
    // console.log("Errors", errors);

    if (valid) {
      var response = await api.post("/light-signup", registerData);
      if (response.status === 200) {
        closeLoginModal();
        swal({
          title: __("Account Created Successfully!"),
          icon: "success",
        });
        props.showAlert(
          "Registration Complete!",
          "Thank You, A confirmation email has been sent to the email address you have listed in your profile. Please follow the instructions in that email in order to activate your account.",
          false
        );
      } else {
        closeLoginModal();
        swal({
          title: response.data.message,
          icon: "error",
        });
      }
    }
  };

  // login functionalities

  const [showLoginPass, setShowLoginPass] = useState(false);

  const toggleShowLoginPass = () => {
    if (showLoginPass) {
      setShowLoginPass(false);
    } else {
      setShowLoginPass(true);
    }
  };

  const [loginErrors, setLoginErrors] = useState({});
  const loginValidateForm = () => {
    var valid = true;
    var errorsTmp = {};
    if (loginData.email < 2 || loginData.email.length > 250) {
      errorsTmp = { ...errorsTmp, email: __("Please enter your email") };
      valid = false;
    }
    if (!emailValidate(loginData.email)) {
      errorsTmp = { ...errorsTmp, email: __("Your email not valid") };
      valid = false;
    }

    if (loginData.password < 2 || loginData.password.length > 250) {
      errorsTmp = { ...errorsTmp, password: __("Please enter password") };
      valid = false;
    }
    setLoginErrors(errorsTmp);
    return valid;
  };
  const updateLoginForm = (field, value) => {
    setLoginData({ ...loginData, [field]: value });
  };

  const [acceptLoginField, setAcceptLoginField] = useState({
    email: 0,
    password: 0,
  });

  // console.log("User", updateUserObj);

  const loginInputChange = (ev) => {
    var target = ev.target;
    var field = target.name;
    var value = target.value;

    if (field == "email") {
      if (emailValidate(value)) {
        setAcceptLoginField({ ...acceptLoginField, email: 1 });
        setLoginErrors({ ...loginErrors, email: "" });
      } else {
        setAcceptLoginField({ ...acceptLoginField, email: 2 });
        setLoginErrors({ ...loginErrors, email: __("Your email not valid") });
      }
    }

    if (field == "password") {
      if (
        validator.isStrongPassword(value, {
          minLength: 8,
          minLowercase: 1,
          minUppercase: 1,
          minNumbers: 1,
          minSymbols: 1,
        })
      ) {
        setAcceptLoginField({ ...acceptLoginField, password: 1 });
        setLoginErrors({ ...loginErrors, password: "" });
      } else {
        setAcceptLoginField({ ...acceptLoginField, password: 2 });
      }
    }
    updateLoginForm(field, value);
  };

  const [loginData, setLoginData] = useState({
    email: "",
    password: "",
  });

  // console.log("djksdjsk", acceptLoginField);

  const loginAction = async (event) => {
    event.preventDefault();
    var valid = loginValidateForm();
    if (valid) {
      var response = await api.post("/login", loginData);
      setSpinner(false);
      if (response.status === 200) {
        closeLoginModal();
        swal({
          title: __("Successfully Logged In!"),
          icon: "success",
        });
        await auth.login(response.data.user);
        updateUserObj();
      } else if (response.status === 423) {
        closeLoginModal();
        swal({
          title:
            response.data.message +
            "\n\n" +
            __(
              "If you did not receive the activation email, please close this message to go to the activation page."
            ),
          icon: "warning",
        });
        history.push("/activate-account/" + loginData.email);
      } else {
        closeLoginModal();
        swal({
          title: response.data.message,
          icon: "warning",
        });
      }
    }
  };

  // recoverModal

  //forgot Password functionalies

  const [sentForgotPassMail, setSentForgotPassMail] = useState(false);
  const [forgotErrors, setForgotErrors] = useState({});
  const forgotValidateForm = () => {
    var valid = true;
    var errorsTmp = {};
    if (forgotData.email < 2 || forgotData.email.length > 250) {
      errorsTmp = { ...errorsTmp, email: __("Please enter your email") };
      valid = false;
    }
    if (!emailValidate(forgotData.email)) {
      errorsTmp = { ...errorsTmp, email: __("Your email not valid") };
      valid = false;
    }
    setForgotErrors(errorsTmp);
    return valid;
  };

  const updateForgotForm = (field, value) => {
    setForgotData({ ...forgotData, [field]: value });
  };

  const [acceptForgotField, setAcceptForgotField] = useState({
    email: 0,
  });

  const forgotInputChange = (ev) => {
    var target = ev.target;
    var field = target.name;
    var value = target.value;
    if (field == "email") {
      if (emailValidate(value)) {
        setAcceptForgotField({ ...acceptForgotField, email: 1 });
        setForgotErrors({ ...forgotErrors, email: "" });
      } else {
        setAcceptForgotField({ ...acceptForgotField, email: 2 });
        setForgotErrors({
          ...forgotErrors,
          email: __("Your email not valid"),
        });
      }
    }

    updateForgotForm(field, value);
  };

  const [forgotData, setForgotData] = useState({
    email: "",
  });

  const forgotAction = async (event) => {
    event.preventDefault();
    var valid = forgotValidateForm();
    if (valid) {
      var response = await api.post("/request-reset-password", forgotData);
      // console.log("responseresponseresponse", response);
      if (response.status === 200) {
        swal({
          title: __("Password Reset"),
          text: __(
            "A password recovery email has been sent to your provided email address."
          ),
          icon: "success",
        });
        history.push("/");
      } else {
        swal({
          title: __("Error!"),
          icon: "warning",
          text: response.data.message,
        });
      }
    }
  };

  // hjsdhsjdhsjdh

  // const [maxDate, setMaxDate] = useState();

  useEffect(() => {
    if (props.modalSignUpPropsData == true) {
      // REGISTER DATA
      setErrors({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        password: "",
        dateOfBirth: "",
        agreeToTerms: "",
        accept_country_limit: "",
      });
      setRegisterData({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        password: "",
        dateOfBirth: "",
        agreeToTerms: 0,
        accept_country_limit: "no",
      });
      setAcceptField({
        firstName: 0,
        lastName: 0,
        email: 0,
        phone: 0,
        password: 0,
        // confirm_password: 0,
        dateOfBirth: 0,
      });

      setShowLoginModal(props.modalSignUpPropsData);
      setActiveTab("register");
    }

    if (props.modalLoginPropsData == true) {
      // LOGIN DATA
      setLoginData({
        email: "",
        password: "",
      });
      setAcceptLoginField({
        email: 0,
        password: 0,
      });
      setLoginErrors({
        email: "",
        password: "",
      });
      setShowLoginModal(props.modalLoginPropsData);
      setActiveTab("login");
    }

    // RECOVER DATA
    setAcceptForgotField({
      email: 0,
    });
    setForgotData({
      email: "",
    });
    setForgotErrors({
      email: "",
    });
  }, [props]);

  // useEffect(() => {
  //   var today = new Date();
  //   var dd = today.getDate();
  //   var mm = today.getMonth() + 1; //January is 0!
  //   var yyyy = today.getFullYear() - 18;
  //   if (dd < 10) {
  //     dd = "0" + dd;
  //   }
  //   if (mm < 10) {
  //     mm = "0" + mm;
  //   }

  //   today = yyyy + "-" + mm + "-" + dd;
  //   setMaxDate(today);
  // }, []);

  const currentDate = new Date();

  // Calculate the date 18 years ago
  const eighteenYearsAgo = new Date(currentDate);
  eighteenYearsAgo.setFullYear(currentDate.getFullYear() - 18);

  // Format the date (e.g., YYYY-MM-DD)
  const maxDate = `${eighteenYearsAgo.getFullYear()}-${(
    eighteenYearsAgo.getMonth() + 1
  )
    .toString()
    .padStart(2, "0")}-${eighteenYearsAgo
    .getDate()
    .toString()
    .padStart(2, "0")}`;

  //Date Picker

  const today = new Date();
  const eighteenYearsAgoDate = new Date();
  eighteenYearsAgoDate.setFullYear(today.getFullYear() - 18);
  const [mxDate, setMxDate] = useState(eighteenYearsAgo.toLocaleDateString());
  const [startDate, setStartDate] = useState("");

  return (
    <>
      {spinner && <Spinner />}
      <Modal
        className="main_popup"
        show={showLoginModal}
        onHide={closeLoginModal}
        size="xl"
        centered
      >
        <Modal.Body>
          <div className="modalHeader">
            <div className="logo">
              <img
                src={require("../assets/images/new-landing/logo.png").default}
                alt="Card-Icon"
              />
            </div>
            <div onClick={closeLoginModal} className="close_button" closeButton>
              <i className="far fa-times"></i>
            </div>
          </div>
          <br />
          <div className="top_area">
            <div className="badge">{__("Welcome")}</div>
          </div>
          <div className="reg_area">
            <div className="row">
              <div className="col-md-12 col-lg-5">
                <div className="login_area_img">
                  <img
                    alt="game image"
                    src="https://chimpbytes.imgix.net/login-popup-bg.png?&dpr=1&format=auto&auto=format&w=435&h=496&max-age=2629056"
                  />
                </div>
                {/* <div className="logo">
                  <img
                    src={require("assets/images/new-landing/logo.png").default}
                    alt="Card-Icon"
                  />
                </div> */}
              </div>
              <div className="col-md-12 col-lg-7">
                {activeTab === "register" && (
                  <form id="registerForm" onSubmit={registerAction}>
                    <div className="form_area slideUpAnimation">
                      <div className="form_headline">{__("Sign Up")}</div>
                      <div className="form_headline dsc">
                        {__("Already have an account?")}{" "}
                        <Link
                          className={props.landingType}
                          onClick={() => setActiveTab("login")}
                        >
                          {__("Login")}
                        </Link>
                      </div>

                      <div className="form">
                        <div>
                          <div className="input_group">
                            <div
                              className="input_label"
                              onClick={() => {
                                autofocusName("firstName");
                              }}
                            >
                              {__("First Name")}
                            </div>
                            <input
                              onChange={registerInputChange}
                              type="text"
                              name="firstName"
                              id="firstName"
                              className="input_box focus_border_none"
                              value={registerData.firstName}
                            />
                            <div
                              className={
                                acceptField.firstName == 0
                                  ? "icon "
                                  : acceptField.firstName == 1
                                  ? "icon success"
                                  : "icon error"
                              }
                            >
                              <i
                                className={
                                  acceptField.firstName == 1
                                    ? "fa fa-check"
                                    : "fa fa-times"
                                }
                              ></i>
                            </div>
                          </div>
                          <div className="error_msg">{errors.firstName}</div>
                        </div>
                        <div>
                          <div className="input_group">
                            <div
                              className="input_label"
                              onClick={() => {
                                autofocusName("lastName");
                              }}
                            >
                              {__("Last Name")}
                            </div>
                            <input
                              onChange={registerInputChange}
                              type="text"
                              name="lastName"
                              id="lastName"
                              className="input_box focus_border_none"
                              value={registerData.lastName}
                            />
                            <div
                              className={
                                acceptField.lastName == 0
                                  ? "icon "
                                  : acceptField.lastName == 1
                                  ? "icon success"
                                  : "icon error"
                              }
                            >
                              <i
                                className={
                                  acceptField.lastName == 1
                                    ? "fa fa-check"
                                    : "fa fa-times"
                                }
                              ></i>
                            </div>
                          </div>
                          <div className="error_msg">{errors.lastName}</div>
                        </div>
                        <div>
                          <div className="input_group">
                            <div
                              className="input_label"
                              onClick={() => {
                                autofocusName("email");
                              }}
                            >
                              {__("Email ID")}
                            </div>
                            <input
                              onChange={registerInputChange}
                              type="email"
                              name="email"
                              id="email"
                              className="input_box focus_border_none"
                              value={registerData.email}
                            />
                            <div
                              className={
                                acceptField.email == 0
                                  ? "icon "
                                  : acceptField.email == 1
                                  ? "icon success"
                                  : "icon error"
                              }
                            >
                              <i
                                className={
                                  acceptField.email == 1
                                    ? "fa fa-check"
                                    : "fa fa-times"
                                }
                              ></i>
                            </div>
                          </div>
                          <div className="error_msg">{errors.email}</div>
                        </div>
                        <div>
                          <div className="input_group">
                            <div
                              className="input_label"
                              onClick={() => {
                                autofocusName("phone");
                              }}
                            >
                              {__("Phone")}
                            </div>
                            <input
                              onChange={registerInputChange}
                              type="tel"
                              name="phone"
                              id="phone"
                              className="input_box focus_border_none"
                              value={registerData.phone}
                            />
                            <div
                              className={
                                acceptField.phone == 0
                                  ? "icon "
                                  : acceptField.phone == 1
                                  ? "icon success"
                                  : "icon error"
                              }
                            >
                              <i
                                className={
                                  acceptField.phone == 1
                                    ? "fa fa-check"
                                    : "fa fa-times"
                                }
                              ></i>
                            </div>
                          </div>
                          <div className="error_msg">{errors.phone}</div>
                        </div>
                        <div>
                          <div className="input_group">
                            <div
                              className="input_label"
                              onClick={() => {
                                autofocusName("password");
                              }}
                            >
                              {__("Password")}
                            </div>
                            <input
                              onChange={registerInputChange}
                              type={showRegisterPass ? "text" : "password"}
                              name="password"
                              id="password"
                              className="input_box focus_border_none"
                              value={registerData.password}
                            />
                            <div
                              onClick={toggleShowRegisterPass}
                              className="show_pass_icon"
                            >
                              <i
                                class={
                                  showRegisterPass
                                    ? "fas fa-eye-slash"
                                    : "fas fa-eye"
                                }
                              ></i>
                            </div>
                            <div
                              className={
                                acceptField.password == 0
                                  ? "icon "
                                  : acceptField.password == 1
                                  ? "icon success"
                                  : "icon error"
                              }
                            >
                              <i
                                className={
                                  acceptField.password == 1
                                    ? "fa fa-check"
                                    : "fa fa-times"
                                }
                              ></i>
                            </div>
                          </div>
                          <div className="error_msg">{errors.password}</div>
                        </div>
                        {/* <DatePickerNew {...props} /> */}

                        <div>
                          <div className="input_group">
                            <div
                              className="input_label"
                              onClick={() => {
                                autofocusName("dateOfBirth");
                              }}
                            >
                              {__("Day of birth")}
                            </div>
                            {/* <input
                              onChange={registerInputChange}
                              type="date"
                              name="dateOfBirth"
                              id="dateOfBirth"
                              className="input_box focus_border_none"
                              max={maxDate}
                              value={registerData.dateOfBirth}
                            /> */}
                            <DatePicker
                              selected={startDate}
                              onChange={(date) => {
                                setStartDate(date);
                                // registerInputChange(this);

                                if (date) {
                                  setAcceptField({
                                    ...acceptField,
                                    dateOfBirth: 1,
                                  });
                                  setErrors({ ...errors, dateOfBirth: "" });
                                } else {
                                  setAcceptField({
                                    ...acceptField,
                                    dateOfBirth: 2,
                                  });
                                  setErrors({
                                    ...errors,
                                    dateOfBirth: __("Please enter birthday"),
                                  });
                                }
                                setRegisterData({
                                  ...registerData,
                                  ["dateOfBirth"]: date,
                                });
                                // console.log(
                                //   "registerDataregisterData",
                                //   registerData
                                // );
                              }}
                              maxDate={addDays(new Date(mxDate), 0)}
                              showMonthDropdown
                              showYearDropdown
                              dropdownMode="select"
                              dateFormat={"yyyy-MM-dd"}
                              placeholderText="Select your date of birth"
                              className="input_box focus_border_none"
                              name="dateOfBirth"
                            />

                            <div
                              className={
                                acceptField.dateOfBirth == 0
                                  ? "icon "
                                  : acceptField.dateOfBirth == 1
                                  ? "icon success"
                                  : "icon error"
                              }
                            >
                              <i
                                className={
                                  acceptField.dateOfBirth == 1
                                    ? "fa fa-check"
                                    : "fa fa-times"
                                }
                              ></i>
                            </div>
                          </div>
                          <div className="error_msg">{errors.dateOfBirth}</div>
                        </div>

                        <div className="terms padding_bottom_15">
                          <input
                            id="register_tos-accept-checkbox"
                            name="agreeToTerms"
                            className="form-check-input"
                            type="checkbox"
                            onChange={registerInputChange}
                            value={registerData.agreeToTerms}
                          />
                          <label htmlFor="register_tos-accept-checkbox">
                            {"  "} {__("I Accept")}{" "}
                            <Link
                              onClick={() => {
                                props.setOpenCMSModal(true);
                                props.setOpenCMSModalTab("terms_conditions");
                                // closeLoginModal();
                                // setLegalTab("Terms & conditions");
                              }}
                              className={props.landingType}
                              to="#"
                            >
                              {__("terms and conditions")}
                            </Link>{" "}
                            &{" "}
                            <Link
                              onClick={() => {
                                props.setOpenCMSModal(true);
                                props.setOpenCMSModalTab("privacy_policy");
                                // closeLoginModal();
                                // setLegalTab("Terms & conditions");
                              }}
                              className={props.landingType}
                              to="#"
                            >
                              {__("privacy policy")}
                            </Link>
                          </label>

                          <div className="error_msg">{errors.agreeToTerms}</div>
                        </div>
                        <div className="submit_btn">
                          <button
                            type="submit"
                            className={"angle_btn  " + props.landingType}
                          >
                            {__("Register")}
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="25"
                              height="25"
                              fill="red"
                              class="bi bi-arrow-right"
                              viewBox="0 0 16 16"
                            >
                              <path
                                fill-rule="evenodd"
                                d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                              />
                            </svg>
                          </button>
                        </div>
                      </div>

                      <div className="social_login d-none">
                        <div className="social_text">
                          {__("Login with social media")}
                        </div>
                        <div className="links">
                          <Link to="#">
                            <i class="fab fa-instagram"></i>
                          </Link>
                          <Link to="#">
                            <i class="fab fa-linkedin-in"></i>
                          </Link>
                          <Link to="#">
                            <i class="fab fa-facebook-f"></i>
                          </Link>
                          <Link to="#">
                            <i class="fab fa-twitter"></i>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </form>
                )}

                {activeTab === "login" && (
                  <form
                    id="loginForm"
                    autoComplete="off"
                    onSubmit={loginAction}
                  >
                    <div className="form_area slideUpAnimation">
                      <div className="form_headline">{__("Sign In")}</div>
                      <div className="form_headline dsc">
                        <div>
                          {__("Don't have an account?")}{" "}
                          <Link
                            className={props.landingType}
                            onClick={() => setActiveTab("register")}
                          >
                            {__("Register")}{" "}
                          </Link>
                        </div>
                        <div>
                          {__("Forgot Password?")}{" "}
                          <Link
                            onClick={() => setActiveTab("recover_password")}
                            className={props.landingType}
                          >
                            {__("Recover Now")}{" "}
                          </Link>
                        </div>
                      </div>

                      <div className="form">
                        <div>
                          <div className="input_group">
                            <div
                              className="input_label"
                              onClick={() => {
                                autofocusName("login_email");
                              }}
                            >
                              {__("Your email")}
                            </div>
                            <input
                              onChange={loginInputChange}
                              type="email"
                              name="email"
                              id="login_email"
                              className="input_box focus_border_none"
                              value={loginData.email}
                              autoComplete="off"
                            />
                            <div
                              className={
                                acceptLoginField.email == 0
                                  ? "icon "
                                  : acceptLoginField.email == 1
                                  ? "icon success"
                                  : "icon error"
                              }
                            >
                              <i
                                className={
                                  acceptLoginField.email == 1
                                    ? "fa fa-check"
                                    : "fa fa-times"
                                }
                              ></i>
                            </div>
                          </div>
                          <div className="error_msg">{loginErrors.email}</div>
                        </div>

                        <div>
                          <div className="input_group">
                            <div
                              className="input_label"
                              onClick={() => {
                                autofocusName("login_password");
                              }}
                            >
                              {__("Password")}
                            </div>
                            <input
                              onChange={loginInputChange}
                              type={showLoginPass ? "text" : "password"}
                              name="password"
                              className="input_box focus_border_none"
                              value={loginData.password}
                              id="login_password"
                              autoComplete="off"
                            />
                            <div
                              onClick={toggleShowLoginPass}
                              className="show_pass_icon"
                            >
                              <i
                                class={
                                  showLoginPass
                                    ? "fas fa-eye-slash"
                                    : "fas fa-eye"
                                }
                              ></i>
                            </div>
                            <div
                              className={
                                acceptLoginField.password == 0
                                  ? "icon "
                                  : acceptLoginField.password == 1
                                  ? "icon success"
                                  : "icon error"
                              }
                            >
                              <i
                                className={
                                  acceptLoginField.password == 1
                                    ? "fa fa-check"
                                    : "fa fa-times"
                                }
                              ></i>
                            </div>
                          </div>
                          <div className="error_msg">
                            {loginErrors.password}
                          </div>
                        </div>

                        <div className="submit_btn">
                          <button
                            type="submit"
                            className={"angle_btn  " + props.landingType}
                          >
                            {__("Login")}
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="25"
                              height="25"
                              fill="red"
                              class="bi bi-arrow-right"
                              viewBox="0 0 16 16"
                            >
                              <path
                                fill-rule="evenodd"
                                d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                              />
                            </svg>
                          </button>
                        </div>
                      </div>

                      <div className="social_login d-none">
                        <div className="social_text">
                          {__("Login with social media")}
                        </div>
                        <div className="links">
                          <Link to="#">
                            <i class="fab fa-instagram"></i>
                          </Link>
                          <Link to="#">
                            <i class="fab fa-linkedin-in"></i>
                          </Link>
                          <Link to="#">
                            <i class="fab fa-facebook-f"></i>
                          </Link>
                          <Link to="#">
                            <i class="fab fa-twitter"></i>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </form>
                )}

                {activeTab === "recover_password" && (
                  <form onSubmit={forgotAction}>
                    <div className="form_area slideUpAnimation">
                      <div className="form_headline">
                        {" "}
                        {__("Recover Password")}
                      </div>
                      <div className="form_headline dsc margin_bottom_30">
                        {__("Back to")}{" "}
                        <Link
                          className={props.landingType}
                          onClick={() => setActiveTab("login")}
                          to="#"
                        >
                          {__("Login")}
                        </Link>
                      </div>

                      <div className="form">
                        {!sentForgotPassMail && (
                          <div>
                            <div className="input_group">
                              <div
                                className="input_label"
                                onClick={() => {
                                  autofocusName("forget_email");
                                }}
                              >
                                {__("Your email")}
                              </div>
                              <input
                                value={forgotData.email}
                                onChange={forgotInputChange}
                                type="email"
                                name="email"
                                id="forget_email"
                                className="input_box focus_border_none"
                              />
                              <div
                                className={
                                  acceptForgotField.email == 0
                                    ? "icon "
                                    : acceptForgotField.email == 1
                                    ? "icon success"
                                    : "icon error"
                                }
                              >
                                <i
                                  className={
                                    acceptForgotField.email == 1
                                      ? "fa fa-check"
                                      : "fa fa-times"
                                  }
                                ></i>
                              </div>
                            </div>
                            <div className="error_msg">
                              {forgotErrors.email}
                            </div>
                          </div>
                        )}

                        {sentForgotPassMail && (
                          <p className="recovery_success text-white">
                            {__(
                              "A password recovery email has been sent to your provided email address."
                            )}
                          </p>
                        )}

                        <div className="submit_btn">
                          <button
                            type="submit"
                            className={"angle_btn " + props.landingType}
                          >
                            {__("Next")}
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="25"
                              height="25"
                              fill="red"
                              class="bi bi-arrow-right"
                              viewBox="0 0 16 16"
                            >
                              <path
                                fill-rule="evenodd"
                                d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                              />
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                )}
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default LoginReg;
